<template>
  <div class="column is-full privacy">
    <b-collapse class="card-main"
      animation="slide"
      v-for="(collapse, index) of collapses"
      :key="index"
      :open="isOpen == index"
      @open="isOpen = index"
      :aria-id="'contentIdForA11y5-' + index"
    >
      <template #trigger="props">
        <div
          class="card-header"
          role="button"
          :aria-controls="'contentIdForA11y5-' + index"
          :aria-expanded="props.open"
        >
          <p class="card-header-title is-size-5 has-text-weight-normal has-text-info">
            {{ collapse.title }}
          </p>
          <a class="card-header-icon">
            <b-icon :icon="props.open ? 'chevron-up' : 'chevron-down'"> </b-icon>
          </a>
        </div>
      </template>
      <div class="card-content">
        <div class="content is-size-5 has-text-grey is-size-6">
          {{ collapse.text }}
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "PrivacyAccordion",
  data() {
    return {
      isOpen: 0,
      collapses: [
        {
          title: "Maaşları Nasıl Hesaplıyoruz?",
          text: "Kullanıcılarımızın yanıtladığı maaş anketi verilerini kullanarak maaş verisi hesaplamasını yapıyoruz. Maaş verileri sektör, işveren ve lokasyona bağlı olarak değişen benzersiz verilerdir. Yani aynı mesleğe sahip ancak farklı lokasyonda ve işyerinde çalışan veya daha deneyimli kişilerin maaşları farklılık gösterebilir.",
        },
        {
          title: "Maaş Bilgilerini Nasıl Güncel Tutuyoruz?",
          text: "Çalışma hayatındaki herkesin katılabileceği anketler oluşturuyor ve anlık veri akışı yaparak sonuçları otomatik güncelliyoruz. Ek olarak, veri analizi uzmanlarımız enflasyon etkisi, maaş zam oranları gibi ekonomik değişkenleri de hesaplamaya dahil ediyor.",
        },
        {
          title: "Gizliliğini Nasıl Koruyoruz?",
          text: "Bizimle paylaştığın verileri isimsiz olarak yayınlıyor ve kişisel bilgilerini kesinlikle paylaşmıyoruz. Bu veriler sadece maaşları incelemen ve iş arayanlara yardımcı olman için kullanılır.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.card-header {
  box-shadow: none;
}
.card-content {
  padding-top: 0;
  padding-left: 12px;
  padding-right: 12px;
}
.card-main{
  border-bottom: 1px solid #CDD2E1;
}


</style>
